module.exports = __webpack_public_path__ + "./images/41af57f495799ba18d3ae73d7913d07c.webp";